import AppStoreLinkQRCode from 'assets/apple-store-link.png';
import React, { useState } from 'react';
import { CloseIcon } from '@mm/icons';
import appIcon from './app-icon.svg';
import styles from './MobileDownload.module.css';
import { CloseModalProps } from '../modal-helpers';

export const MobileDownload = (props: CloseModalProps) => {
  const { closeModal } = props;
  const [showQRCode, setShowQRCode] = useState(false);

  return (
    <div className={styles.container}>
      <CloseIcon
        className={styles.closeIcon}
        onClick={closeModal}
        color="#262626"
      />
      {!showQRCode ? (
        <div>
          <img src={appIcon} className={styles.logo} />
          <div className={styles.heading}>
            Install the MobileMonkey App for iOS/Android
          </div>
          <div className={styles.description}>
            So that you can be notified of Unicorn Leads at any time and respond
            while they are engaged
          </div>
          <div className={styles.storelinksWrapper}>
            <div onClick={() => setShowQRCode(true)}>
              <img
                className={styles.mobileBadgeIOS}
                alt="Download on the App Store"
                // tslint:disable-next-line: max-line-length
                src="https://linkmaker.itunes.apple.com/en-us/badge-lrg.svg?releaseDate=2019-10-03&kind=iossoftware&bubble=ios_apps"
              />
            </div>
            <div>
              <a
                // tslint:disable-next-line: max-line-length
                href="https://play.google.com/store/apps/details?id=com.mobilemonkey&utm_source=web_app&utm_campaign=livechat_notification&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
                target="_blank"
              >
                <img
                  className={styles.mobileBadgeGoogle}
                  alt="Get it on Google Play"
                  src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                />
              </a>
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.QRCodesContainer}>
          Scan on your mobile device to view in the App Store
          <img alt="Scan App Store Link QR Code" src={AppStoreLinkQRCode} />
        </div>
      )}
    </div>
  );
};
